import { TRouteOverrides } from './types';

export const routeOverrides: TRouteOverrides = {};
